<template>
  <v-card :loading="loading" class="havet-card" elevation="2">
    <div class="top-row">
      <h4>{{ label }}</h4>
    </div>
    <div class="list mt-2">
      <div
        class="list-item"
        v-for="item in items"
        :key="item.id"
        @click="$emit('news:goto', { id: item.id })"
      >
        <v-chip class="mr-2 chip" label pill small :color="item.news_publish | labelColor">
          {{ item.news_publish | label }}
        </v-chip>

        <v-tooltip top dark>
          <template v-slot:activator="{ on, attrs }">
            <span class="text" v-bind="attrs" v-on="on"> {{ item.news_title }}</span>
          </template>
          <div class="news-title">{{ item.news_title }}</div>
        </v-tooltip>
        <div class="news-date">{{ item.created_at | prettyDate }}</div>
      </div>
    </div>
    <div class="pagination-container">
      <slot name="pagination"></slot>
    </div>
  </v-card>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { getColor } from '@/assets/data/colors'

export default {
  name: 'LatestNews',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    items: {
      type: [Array, Object],
    },
    label: {
      type: String,
      default: 'Senaste nyheterna',
    },
    meta: {
      type: Object,
    },
  },
  components: {},
  filters: {
    prettyDate(date) {
      try {
        return format(parseISO(date), 'yyyy-MM-dd')
      } catch (err) {
        return date
      }
    },
    label(status) {
      if (status === 'authorize') return 'Ny'
      if (status === 'offline') return 'Utkast'
      if (status === 'online') return 'Publicerad'
      return ''
    },
    labelColor(status) {
      return getColor(status)
    },
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.havet-card {
  width: 100%;
  max-width: 100%;
  .top-row {
    padding-left: 15px;
    padding-top: 12px;
  }
  .list {
    font-size: 0.9rem;
    overflow: auto;
    max-height: 100%;
    .list-item {
      display: grid;
      grid-template-columns: 95px 1fr 75px;
      grid-template-rows: 1fr;
      grid-column-gap: 5px;
      grid-row-gap: 0px;
      padding: 6px 10px;
      border-bottom: #ccc 1px solid;
      white-space: nowrap;
      .text {
        overflow-y: hidden;
        text-overflow: ellipsis;
      }
      .chip{
        display: flex;
    justify-content: center;
      }
      cursor: pointer;
      .news-title {
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news-date {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 10px;
        white-space: nowrap;
      }
    }
  }
  .pagination-container {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
